import { render, staticRenderFns } from "./FileDownloadPost.vue?vue&type=template&id=5b30f0eb&scoped=true"
import script from "./FileDownloadPost.vue?vue&type=script&lang=js"
export * from "./FileDownloadPost.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadPost.vue?vue&type=style&index=0&id=5b30f0eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30f0eb",
  null
  
)

export default component.exports